module.exports = __webpack_public_path__ + "static/media/abe-xray.30278ad5.png";